<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">敏感词</span>
        <el-input v-model.trim="word" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getSensitivePageFn()">
          搜索
        </el-button>
        <el-button type="primary" @click="typeBtn(1)">
          新增
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="content" label="敏感词"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="typeBtn(2, row)">编辑</a>
          <a class="glob-a" @click="typeBtn(3, row)">删除</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    getSensitivePage,
    delSensitive,
    setSensitive,
    addSensitive
  } from '@/api'

  export default {
    name: 'SensitiveWord',
    data () {
      return {
        word: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
      }
    },
    created () {
      this.getSensitivePageFn()
    },
    methods: {
      typeBtn (t, row) {
        switch (t) {
          case 1:
            this.$prompt('请输入敏感词', '新增', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /\S/,
              inputPlaceholder: '请输入',
              inputErrorMessage: '请输入'
            }).then(({value}) => {
              addSensitive({content: value}).then(res => {
                this.$message.success(res.data)
                this.getSensitivePageFn()
              })
            }).catch(() => {
            })
            break
          case 2:
            this.$prompt('请输入敏感词', '修改', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPattern: /\S/,
              inputValue: row.content,
              inputPlaceholder: '请输入',
              inputErrorMessage: '请输入'
            }).then(({value}) => {
              setSensitive({
                sensitiveWordId: row.sensitiveWordId,
                content: value
              }).then(res => {
                this.$message.success(res.data)
                this.getSensitivePageFn()
              })
            }).catch(() => {
            })
            break
          case 3:
            this.$confirm('确认删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              delSensitive(row.sensitiveWordId).then(res => {
                this.$message.success(res.data)
                this.getSensitivePageFn()
              })
            }).catch(() => {
            })
            break
        }
      },
      getSensitivePageFn () {
        this.tableLoading = true
        getSensitivePage({
          pageNum: this.pages.page,
          content: this.word,
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getSensitivePageFn()
      },
    }
  }
</script>

<style scoped>

</style>
